import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Market not supported',
  description:
    "The feature you're trying to access is not supported on the currently selected market.",
  buttonTitle: 'Go to dashboard',
});
